let scroller: HTMLElement | Window | null = null

export function setChatScroller(el: HTMLElement | Window | null) {
  scroller = el
}

export function getChatScroller(): HTMLElement | Window | null {
  return scroller
}